import React from 'react';
import classNames from 'classnames';

import styles from './TextArea.module.scss';

export const TextArea = ({
  name,
  label,
  description,
  maxLength,
  showCharacterCount = false,
  shouldDisplayLabel = true,
  isRequired,
  leftIcon: LeftIcon,
  error,
  className,
  ...props
}) => {
  const currentLength = props.value ? props.value.length : 0;

  return (
    <div className={styles.container}>
      {shouldDisplayLabel && (
        <label htmlFor={name} className={styles.label}>
          {label} {isRequired && <span className={styles.required}>*</span>}
        </label>
      )}

      <div className={styles.textareaContainer}>
        {LeftIcon && (
          <div className={styles.leftIcon}>
            <LeftIcon />
          </div>
        )}
        <textarea
          {...props}
          name={name}
          id={name}
          maxLength={maxLength}
          className={classNames(
            styles.textarea,
            {
              [styles.error]: error,
              [styles.withLeftIcon]: LeftIcon,
            },
            className
          )}
        />
      </div>

      {(description || showCharacterCount) && (
        <div className={styles.footer}>
          {description && <p className={styles.description}>{description}</p>}
          {showCharacterCount && maxLength && (
            <span className={styles.characterCount}>
              {currentLength} / {maxLength}
            </span>
          )}
        </div>
      )}

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};
